import * as HERBUI from 'react-bootstrap'
import { usermanualshrpayroll } from '../components/Functions';
import { CommonAjaxGetRequestWithOutParamsWithOutAuthorization } from '../Api/CommonAjaxUtils';
import { AWS_DOWNLOAD_URL } from '../Api/APIURLS';
function MobileNumbersPopUp({ showpopup, handleClose }) {

    const getS3UrlData = async (url) => {
        const resp = await CommonAjaxGetRequestWithOutParamsWithOutAuthorization(
            AWS_DOWNLOAD_URL + url
        );
        if (resp) {
            window.open(resp, "_blank");
        }
    }
    return (
        <div>
            <HERBUI.Modal size='xl' show={showpopup} onHide={handleClose} scrollable={true} dialogClassName="modal-xl modal-dialog2">
                <HERBUI.Modal.Header className="modal-header hr">
                    <HERBUI.Modal.Title>
                        <h5>PSE (Public Sector Entities) HR & Payroll Module – Support Details</h5>
                    </HERBUI.Modal.Title>
                    <button type="button"  className="btn-close"  aria-label="Close" onClick={handleClose} ></button>
                </HERBUI.Modal.Header>

                <HERBUI.Modal.Body className="modal-body">

                    {/* ===== Contact Numbers Table ===== */}
                    <h6 className="mb-2"><b>Technical Supporting Team Contact Numbers</b></h6>

                    <HERBUI.Table bordered hover responsive className="text-center table-sm">
                        <thead
                            style={{
                                fontSize: "13px",
                                textAlign: "center",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
                            }}
                            className="table table-hover table-bordered table-sm"
                        >
                            <tr>
                                <th>SL.NO</th>
                                <th>NAME</th>
                                <th>MOBILE NUMBER</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td>1</td><td>Bharth</td><td>9966263536</td></tr>
                            <tr><td>2</td><td>Srinivas</td><td>9000316346</td></tr>
                            <tr><td>3</td><td>Venkat</td><td>8008944387</td></tr>
                            <tr><td>4</td><td>Ruby</td><td>7995503984</td></tr>
                            <tr><td>5</td><td>Mounika</td><td>8008862087</td></tr>
                            <tr><td>6</td><td>Soundarya</td><td>9676075867</td></tr>
                            <tr><td>7</td><td>Bhagya</td><td>9063363117</td></tr>
                            <tr><td>8</td><td>Kalyani</td><td>8985787635</td></tr>
                        </tbody>
                    </HERBUI.Table>

                    {/* ===== Spacer ===== */}
                    <hr className="my-4" />

                    {/* ===== User Guides Table ===== */}
                    <h6 className="mb-2"><b>User Guides</b></h6>

                    <HERBUI.Table bordered hover responsive className="table-sm">
                        <thead className="table table-hover table-bordered table-sm text-center">
                            <tr>
                                <th>SL.NO</th>
                                <th>DESCRIPTION</th>
                                <th>ACTION</th>
                            </tr>
                        </thead>
                        <tbody>
                           
                            {usermanualshrpayroll.map((sec, idx) => {
                                return (<tr key={idx}>
                                    <td className="text-center">{idx + 1}</td>
                                    <td>{sec.title}</td>
                                    <td className="text-center">
                                        <button   onClick={() => getS3UrlData(sec.downloadUrl)} style={{ cursor: "pointer" }}
                                            className="link-button">
                                            {'Download'}
                                        </button>
                                    </td>

                                </tr>)
                            })}
                        </tbody>
                    </HERBUI.Table>

                </HERBUI.Modal.Body>

                <HERBUI.Modal.Footer className="modal-footer">
                    <HERBUI.Button className="btnClose btn-sm" onClick={handleClose}>
                        <b>Close</b>
                    </HERBUI.Button>
                </HERBUI.Modal.Footer>
            </HERBUI.Modal>
        </div>
    );
}

export default MobileNumbersPopUp;
